import React, {useCallback, useEffect} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {History} from 'history';
import Form from './Form';
import {adminRoutes} from '../../App/AppRouter/routes';
import {AppName, Device} from '../Redux/Types';

export interface FormProps {
    item: AppName;
    isLoading: boolean;
    devices: Device[];
    errors: { [key: string]: string };
    saveCompleted: boolean;
    load: (id: string) => void;
    update: (id: string, entity: Partial<AppName>) => void;
    loadDevices: () => void;
    clean: () => void;
    setNotification: (params: { type: string, text: string}) => void;
}

const onHistoryRoutePush = (history: History) => () => {
    history.push(adminRoutes.appNameListPage);
};

const saveHandler = (id: string, update: (id: string, entity: Partial<AppName>) => void) => (entity: AppName) => {
    update(id, {
        name: entity.name,
        devices: entity.devices,
    });
};

export default (props: FormProps) => {
    const {item, saveCompleted, devices, load, update, loadDevices, clean, setNotification} = props;
    const {id}: { id: string } = useParams();
    
    const history = useHistory();
    const pushRouteToHistory = onHistoryRoutePush(history);
    const goBack = useCallback(() => {
        setTimeout(() => {
            clean();
            pushRouteToHistory();
        }, 0);
    }, [clean, pushRouteToHistory]);
    const onSaveHandler = saveHandler(id, update);
    
    useEffect(() => {
        if (saveCompleted) {
            setNotification({
                type: 'success',
                text: 'App profile successfully saved',
            });
            goBack();
        }
    }, [saveCompleted, goBack, setNotification]);
    
    useEffect(() => {
        loadDevices();
    }, [loadDevices]);
    
    useEffect(() => {
        load(id);
    }, [load, id]);
    
    if (!item || item._id !== id || !devices) {
        return <>Loading...</>;
    }
    
    return (
        <Form
            entity={item}
            deviceList={devices}
            onCancelHandler={goBack}
            onSaveHandler={onSaveHandler}
        />
    );
};
